/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Layout, Header, BuddyTab, /*NoData, AddUserCard, HeaderTitle,*/ ButtonHris, /*Wrapper,*/ StyledModal, PopupLine, DownAngle, Heading, AddButton, BackgroundCard, ShowFlexBox, HrisCardDisconnect} from './style';
import { ImageUrl } from '../../utils/constants';
import { toast } from "react-toastify";
import { BASE_URL } from "../../utils/config";
import { fetchApi } from "../../utils/methods";
// import {AdminEventsAddCreateEventButton} from '../../utils/icons'
import { GetApiDeck, GetCurrentIntegrations, UpdateAutoSyncDays, Createorganization, Getorganization, Updateorganization, Deleteorganization, Createconnection, Deleteconnection, Createconsumer, Deleteconsumer, UpdateFieldTypes, ShowConsumer, Synchrisemployees } from "../../redux/constants/apiConstants";
import { useVault } from "@apideck/vault-react";
import HrisCardComponent from './hrisCard';
// import HoverButton from "../common/HoverButton";
import { Dropdown } from "react-bootstrap";
import DropdownButton from 'react-bootstrap/DropdownButton';
import UpdateOrganization from './UpdateOrganization';
import DeletePostPopup from '../DeletePostPopup/deletePostConfirmation'
import {/*AddTeamIcon, DeleteIcon,*/ AddIconBranding, MenuVertical, ArrowRight} from '../../utils/icons'
import CreateConsumer from './createConsumerFile';
import DeletePopup from '../DeletePostPopup/deletePopupBranding'
import {getCompanyBrandingDetails} from '../../redux/actions'
class HrisMain extends Component {
  constructor(props) {
    super();
    this.state = {
      showAdd: true,
      apiDeckConfig: null,
      integrations: [],
      integrationComponentRendered: false,
      companyId: props.companyInfo?.id,
      showSyncPopup: false,
      syncDay:7,
      postSyncResponse: null,
      organizationData: null,
      getOrganizationData: null,
      showOrganization: false,
      domainName: null,
      showOrganizationDelete: false,
      showOrganizationDomain: false,
      organizationDomainName: null,
      getRedirectionUrl: null,
      showConnectionDelete: false,
      showConsumerPopup: false,
      deleteConsumer: false,
      showGeneratePopup: false,
      getConsumers: [],
      synchrisemployee: false,
      domainNameSecondary: null,
      organizationDomainNameSecondary: null
    };
  }

  componentDidMount() {
    this.getCurrentIntegrationsFromVault();
    this.getOrganization()
    this.getConsumerData()
  }

  syncDays = [
    {
      id: 1,
      name: 7
    },
    {
      id: 2,
      name: 14
    },
    {
      id: 3,
      name: 28
    }
  ]

  hideAddCard = () =>{
    this.setState({
      showAdd: false
    })
  }

  getApiDeck = async () => {
    const companyId = this.state.companyId; 
    try {
      const res = await fetchApi(`${GetApiDeck}/${companyId}/${'new_session'}`, "GET");
      if (res.message) {
        toast.error(res.message);
      } else {
        this.setState({
          apiDeckConfig: res.data,
          
        },()=>
        {
          this.manageIntegrations();
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  manageIntegrations = () => {
    const { open } = useVault();
    this.state.apiDeckConfig &&
      this.state.apiDeckConfig.session_token &&
      open({ token: this.state.apiDeckConfig.session_token,onClose:()=>{this.getCurrentIntegrationsFromVault()},onConnectionDelete:()=>{    this.getCurrentIntegrationsFromVault()}});
  };

  isPreviousDate=(timeString) =>{
    const inputDate = new Date(timeString);
    const currentDate = new Date();

    // Set current date to start of the day (midnight) to compare only the date part
    currentDate.setHours(0, 0, 0, 0);

    return inputDate < currentDate;
  }

  getCurrentIntegrationsFromVault = async () => {
    const companyId = this.state.companyId; 
    try {
      const response = await fetchApi(`${GetCurrentIntegrations}/${companyId}/${'new_vault'}`, "GET");
      if (response.message) {
        toast.error(res.message);
      }
      else {
        const LogoData = response?.data
        const enabledData = LogoData?.length>0 && LogoData?.filter((item) => item.enabled);
        const callableData = LogoData?.length>0 ? LogoData?.filter((item) => item.state==="callable"):[];
        const connectedPlatform =callableData?.length>0?callableData?.slice(0, 1): enabledData?.length>0 ? enabledData?.slice(0, 2):[];
        if(callableData?.length>0&&(!connectedPlatform[0]?.last_sync_date|| !connectedPlatform[0]?.next_sync_date||this.isPreviousDate(connectedPlatform[0]?.next_sync_date))){
          this.fetchSynchrisemployees()
        }
        this.setState({ integrations: connectedPlatform,integrationComponentRendered:true, });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  fetchSynchrisemployees = async () => {
    const companyId = this.state.companyId; 
    try {
      const response = await fetchApi(`${Synchrisemployees}/${companyId}`, "GET");
      if (response?.message) {
        // toast.error(res.message);
      }
      else {
        this.setState({synchrisemployee: true})
        setTimeout(() => {
          this.getCurrentIntegrationsFromVault();
        }, 4000);
      }
    } catch (error) {
      // toast.error(error.message);
    }
  };

  sendReminderApiCall = async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let payload = {
      company_id: this.state.companyId,
      days: this.state.syncDay
    };
    let url = BASE_URL + UpdateAutoSyncDays;
    await fetch(url, {
      method: "POST",
      headers: {
        AUTHTOKEN: AuthToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials:'include',
      withCredentials: true,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if (data.data.success_count) {
              this.setState({ showSyncPopup: false} );
              this.getCurrentIntegrationsFromVault();
            } else {
              this.setState({ showSyncPopup: false });
              this.getCurrentIntegrationsFromVault();
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  onCheckboxChange = (id) => {
    const { syncDay } = this.state;
    if(syncDay==id){
      this.setState({
        syncDay: null
      })
    }
    else{
      this.setState({
        syncDay: id
      })}
  };

  syncPopup = () => {
    const { showSyncPopup, syncDay } = this.state;
    return(
      <StyledModal show={showSyncPopup} width={"400px"}>
        <div className='header'>
          <div className='text'>Auto Sync</div>
          <div className='iconCross' onClick={()=>this.showSyncPopup()}>
            <img src={ImageUrl+"/event-section/cross.png"}/>
          </div>
        </div>
        <div className='body'>
          {this.syncDays?.map((data,index)=>(
            <PopupLine key={index}>
              <div className='checkmark' onClick={()=>this.onCheckboxChange(data.name)}>
                {syncDay===data.name&&<img src={ImageUrl+"/ChallengeDetailsScreen/updatedCheckmark.svg"}/>}
              </div>
              <div className='text'>{data.name} Days</div>
            </PopupLine>
          ))}
          <div className='buttonWrapper'>
            <ButtonHris margin="8px" disable={!syncDay} onClick={!syncDay?null: ()=>this.sendReminderApiCall()}>
              Save Changes
            </ButtonHris>
          </div>
        </div>
      </StyledModal>
    )
  }

  showSyncPopup = () =>{
    this.setState({
      showSyncPopup: !this.state.showSyncPopup,
    })
  }

  createOrganization  = async(payload)=>{
    try{
      const res = await fetchApi(Createorganization, "POST",payload);
      if(res.data.message){
        toast.error(res.data.message);
      }else{
        this.hideShowOrganizationDomainPopup()
        this.getOrganization();
        this.setState({
          organizationDomainName: null, organizationDomainNameSecondary:null, domainNameSecondary:null, domainName:null
        })
      }
    }catch(error){
      // toast.error(error)
    }
  }

  getOrganization = async () => {
    const companyId = this.state.companyId; 
    try {
      const res = await fetchApi(`${Getorganization}/${companyId}`, "GET");
      if (res.message) {
        // toast.error(res?.message);
        this.setState({
          getOrganizationData: null,
          domainName:null
        })
      } else {
        this.setState({
          getOrganizationData: res?.data,
          domainName: res?.data && res?.data?.domains?.[0]?.domain,
          domainNameSecondary: res?.data && res?.data?.domains?.[1]?.domain,
        });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  updateOrganizationData = () =>{
    const { domainName, domainNameSecondary } = this.state;
    const organizationSingle = {
      company_id: this.state.companyId,
      domain_data: [
        { domain: domainName, state: "verified" },
      ]
    }
    const organizationMultiple = {
      company_id: this.state.companyId,
      domain_data: [
        { domain: domainName, state: "verified" },
        { domain: domainNameSecondary, state: "verified" }
      ]
    }
    this.updateOrganization(domainNameSecondary?organizationMultiple:organizationSingle);
  }

  createOrganizationData = () =>{
    const { organizationDomainName, organizationDomainNameSecondary } = this.state;
    const organizationSingle = {
      company_id: this.state.companyId,
      domain_data: [
        { domain: organizationDomainName, state: "verified" }
      ]
    }
    const organizationMultiple = {
      company_id: this.state.companyId,
      domain_data: [
        { domain: organizationDomainName, state: "verified" },
        { domain: organizationDomainNameSecondary, state: "verified" }
      ]
    }
    this.createOrganization(organizationDomainNameSecondary?organizationMultiple: organizationSingle);
  }

  updateOrganization  = async(payload)=>{
    try{
      const res = await fetchApi(Updateorganization, "PUT",payload);
      if(res.data.message){
        toast.error(res.data.message);
      }else{
        this.getOrganization();
        this.hideShowOrganizationPopup();
        this.setState({
          organizationDomainName: null, organizationDomainNameSecondary:null, domainNameSecondary:null, domainName:null
        })
      }
    }catch(error){
      // toast.error(error)
    }
  }

  deleteOrganization = async () => {
    const companyId = this.state.companyId; 
    try {
      const res = await fetchApi(`${Deleteorganization}/${companyId}`, "DELETE");
      if (res.message) {
        toast.error(res.message);
      } else {
        this.setState({
          getOrganizationData: null,
          domainName:null
        })
        this.showDeleteOrganization();
        this.getOrganization();
      }
    } catch (error) {
      toast.error(error.message);
      this.getOrganization()
    }
  };

  deleteConnection = async () => {
    const companyId = this.state.companyId; 
    try {
      const res = await fetchApi(`${Deleteconnection}/${companyId}`, "DELETE");
      if (res.message) {
        toast.error(res.message);
      } else {
        this.showDeleteConnection();
        this.getOrganization();
      }
    } catch (error) {
      toast.error(error.message);
      this.getOrganization()
    }
  };

  createConnection  = async()=>{
    const payload = { company_id: this.state.companyId };
    try{
      const res = await fetchApi(Createconnection, "POST",payload);
      if(res.data.message){
        toast.error(res.data.message);

      }else{
        this.getOrganization();
        window.location.href=res.data[0]
      }
    }catch(error){
      // toast.error(error)
    }
  }

  createConsumer  = async(data) =>{
    const payload = data;
    const {companyInfo, getCompanyBrandingDetails} = this.props;
    try{
      const res = await fetchApi(Createconsumer, "POST",payload);
      if(res?.data?.message){
        // this.setState({
        //   showConsumerPopup: false
        // })
        toast.error(res?.data?.message);
      }else{
        this.setState({
          showConsumerPopup: false
        })
        this.getConsumerData();
        getCompanyBrandingDetails(companyInfo?.id)
      }
    }catch(error){
      // toast.error(error)
    }
  }

  deleteConsumer = async () => {
    const companyId = this.state.companyId;
    const {companyInfo, getCompanyBrandingDetails} = this.props;
    try {
      const res = await fetchApi(`${Deleteconsumer}/${companyId}`, "DELETE");
      if (res?.data?.message) {
        this.setState({
          deleteConsumer: false
        })
        toast.error(res?.data?.message);
      } else {
        this.setState({
          deleteConsumer: false
        })
        this.getCurrentIntegrationsFromVault();
        getCompanyBrandingDetails(companyInfo?.id)
        this.getConsumerData()
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  updateConsumerField  = async(data) =>{
    const payload = data;
    try{
      const res = await fetchApi(UpdateFieldTypes, "POST",payload);
      if(res?.data?.message){
        toast.error(res?.data?.message);
      }else{
        setTimeout(() => {
          this.getConsumerData();
          this.setState({showGeneratePopup: false})
        }, 5000);
        this.setState({
          showConsumerPopup: false
        })
      }
    }catch(error){
      // toast.error(error)
    }
  }

  getConsumerData = async () => {
    const companyId = this.state.companyId; 
    try {
      const response = await fetchApi(`${ShowConsumer}/${companyId}`, "GET");
      if (response.message) {
        // toast.error(res.message);
      }
      else {
        this.setState({ getConsumers: response?.data });
      }
    } catch (error) {
      // toast.error(error?.message);
    }
  };

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  hideShowOrganizationPopup = () =>{
    this.setState({
      showOrganization: !this.state.showOrganization
    })
  }

  hideShowOrganizationDomainPopup = () =>{
    this.setState({
      showOrganizationDomain: !this.state.showOrganizationDomain
    })
  }

  showDeleteOrganization = () =>{
    this.setState({
      showOrganizationDelete: !this.state.showOrganizationDelete
    })
  }

  showDeleteConnection = () =>{
    this.setState({
      showConnectionDelete: !this.state.showConnectionDelete
    })
  }

  showHideConsumerPopup = () =>{
    this.setState({
      showConsumerPopup: !this.state.showConsumerPopup
    })
  }

  showHideDeleteConsumer = () =>{
    this.setState({
      deleteConsumer: !this.state.deleteConsumer
    })
  }

  isSSOProviderPresent=(inputString)=> {
    const ssoProviders = [
      { name: "okta",image:"/integration/okta.png" },
      { name: "cas", image:"/integration/cas.png" },
      { name: "entra", image:"/integration/microsoft.png" },
      { name: "azure", image:"/integration/microsoft.png" },
      { name: "google",  image:"/integration/google.png" },
      { name: "workspace", image:"/integration/google.png" },
      { name: "adp", image:"/integration/adp.png" },
      { name: "Auth", image:"/integration/auth.png" },
      { name: "classlink",  image:"/integration/classlink.png" },
      { name: "cloudflare", image:"/integration/classflare.png"  },
      { name: "cyberark", image:"/integration/cyberark.png" },
      { name: "duo",  image:"/integration/duo.png" },
      { name: "jumpcloud", image:"/integration/jumpcloud.png"  },
      { name: "keycloak", image:"/integration/keycloak.png" },
      { name: "lastpass", image:"/integration/lastpas.png"  },
      { name: "login.gov" , image:"/integration/login.png" },
      { name: ".gov" , image:"/integration/login.png" },
      { name: "ad fs", image:"/integration/microsoft.png" },
      { name: "miniorange", image:"/integration/miniorange.png" },
      { name: "NetIQ", image:"/integration/netlq.png" },
      { name: "IQ", image:"/integration/netlq.png" },
      { name: "onelogin", image:"/integration/onelog.png" },
      { name: "oracle", image:"/integration/oracle.png" },
      { name: "PingFederate", image:"/integration/ping.png" },
      { name: "Federate", image:"/integration/ping.png" },
      { name: "Pingone", image:"/integration/pone.png" },
      { name: "rippling", image:"/integration/rippling.png" },
      { name: "salesforce", image:"/integration/salesforce.png" },
      { name: "Shibboleth", image:"/integration/shib.png" },
      { name: "Unsolicited", image:"/integration/shib.png" },
      { name: "SAML" ,image:"/integration/simple.png" },
      { name: "VMware",image:"/integration/vmware.png" }
    ];
  
    const foundProvider = ssoProviders.find((provider) => 
      inputString.toLowerCase().includes(provider.name.toLowerCase())
    );
  
    return foundProvider ? <img src={ImageUrl+foundProvider.image}/> : <img src={ImageUrl+"/integration/sso.png"}/>;
  }

  onCloseGeneratePopup = () => {
    this.setState({
      showGeneratePopup: !this.state.showGeneratePopup
    })
  }

  onRemoveSecondaryDomain = () => {
    this.setState({
      domainNameSecondary: null,
      organizationDomainNameSecondary: null
    })
  }

  render() {
    const { /*showAdd,*/ integrations, getOrganizationData, showOrganization, domainName, showOrganizationDelete, showOrganizationDomain, organizationDomainName, showConnectionDelete, showConsumerPopup, deleteConsumer, showGeneratePopup, getConsumers, domainNameSecondary, organizationDomainNameSecondary } = this.state;
    const {companyInfo, companyLogo, /*companyBranding*/} = this.props;
    // const consumerState= companyBranding?.company_branding?.create_consumer
    const HrisActiveCardStatus = integrations?.some((data) => data.enabled) ? 1 : 0;
    return (
      <Layout>
        <div className='main'>
          <Header isEvent="0px">
            <BuddyTab active>Integrations</BuddyTab>
            {/* <div className='create-consumer'>
              {consumerState?<HoverButton svgPath={DeleteIcon()} activeColor={"#007AB1"} fillOpacity={1} title={"Delete Consumer"} onClick={()=>this.showHideDeleteConsumer()}/>:
                <ButtonHris width="190px" onClick={()=>this.showHideConsumerPopup()}>
                  <div className='addicon'>{AddTeamIcon()}</div>Create Consumer
                </ButtonHris>}
            </div> */}
            {/* <div className='add'>
              <div>
                <Dropdown>
                  <Dropdown.Toggle>
                    <HoverButton svgPath={AdminEventsAddCreateEventButton()} activeColor={"#007AB1"} fillOpacity={1} title={"Integrate"} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={consumerState?()=>this.getApiDeck():null} style={{cursor:consumerState?"pointer":"not-allowed"}}>
                      HRIS
                    </Dropdown.Item>
                    {getOrganizationData?.id? null : <><hr/>
                      <Dropdown.Item onClick={()=>this.hideShowOrganizationDomainPopup()}>
                      Add SSO
                      </Dropdown.Item>
                    </>}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div> */}
          </Header>
          <Heading>SSO Integrations</Heading>
          <ShowFlexBox>
            {getOrganizationData?.name && getOrganizationData?.connections[0]?.raw?.connection_type ?
              <BackgroundCard>
                {getOrganizationData?.connections[0]?.raw?.connection_type&&<HrisCardDisconnect margin="0px">
                  <div className='wrap'>
                    <div className='image'>
                      {this.isSSOProviderPresent(getOrganizationData?.connections[0]?.raw?.connection_type)}
                    </div>
                    <div className='details'>
                      <div className='menu'>
                        <DownAngle backgroundColor widthV="155px" feed style={{display:"flex", margin:"auto 0 auto auto"}} height={"141px"}>
                          <DropdownButton id="editDelete" title={MenuVertical()}>
                            <Dropdown.Item onClick={()=>this.hideShowOrganizationPopup()}>
                              {("Update Domain")}
                            </Dropdown.Item>
                            <div className='line'></div>
                            <Dropdown.Item  onClick={()=>this.showDeleteOrganization()}>
                              {("Delete Domain")}
                            </Dropdown.Item>
                            <div className='line'></div>
                            <Dropdown.Item  onClick={()=>this.showDeleteConnection()}>
                              {("Delete Connection")}
                            </Dropdown.Item>
                          </DropdownButton>
                        </DownAngle>
                      </div>
                      <div className='name'>{getOrganizationData?.connections[0]?.raw?.connection_type}</div>
                      <div className='nextcount'>Primary domain: {getOrganizationData?.domains[0]?.domain}</div>
                      {getOrganizationData?.domains[1]?.domain&&<div className='nextcount'>Secondary domain: {getOrganizationData?.domains[1]?.domain}</div>}
                      {getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state=="active"?<div className='state-green'>{getOrganizationData?.connections[0]?.raw?.state}</div>:
                        <div className='state-red'>{getOrganizationData?.connections[0]?.raw?.state}</div>}
                    </div>
                  </div>
                  {getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state=="active"?null:getOrganizationData?.name &&<ButtonHris width="100%" onClick={()=>this.createConnection()} margin="8px">
                    {getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state!="active"? "Update Connection":"Add Connection+"}
                  </ButtonHris>}
                </HrisCardDisconnect>}
              </BackgroundCard>:
              // getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state=="active"?null:getOrganizationData?.name &&<BackgroundCard width="100px" style={{padding:"16px"}}>
              //   <div className='wrap-drodpwon'>
              //     <div className='text'>{getOrganizationData?.name} </div>
              //     <div className='menu'><DownAngle backgroundColor widthV="145px" feed style={{display:"flex", margin:"auto 0 auto auto"}}>
              //       <DropdownButton id="editDelete" title={MenuVertical()}>
              //         <Dropdown.Item onClick={()=>this.hideShowOrganizationPopup()}>
              //           {("Update Domain")}
              //         </Dropdown.Item>
              //         <div className='line'></div>
              //         <Dropdown.Item  onClick={()=>this.showDeleteOrganization()}>
              //           {("Delete Domain")}
              //         </Dropdown.Item>
              //       </DropdownButton>
              //     </DownAngle></div>
              //   </div>
              //   <div className='incomplete'>Incomplete process</div>
              //   {getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state=="active"?null:
              //     getOrganizationData?.name && <ButtonHris onClick={()=>this.createConnection()}>{getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state!="active"? "Update Connection":"Add Connection+"}</ButtonHris>
              //   }
              // </BackgroundCard>
              getOrganizationData?.connections?.length>0 && getOrganizationData?.connections[0].raw.state=="active"?null:getOrganizationData?.name &&<BackgroundCard>
                <HrisCardDisconnect margin="0px">
                  <div className='wrap'>
                    <div className='image'>
                      <img src={ImageUrl+"/"+this.props.companyLogo?.header_logo}/>
                    </div>
                    <div className='details'>
                      <div className='menu'>
                        <DownAngle  feed style={{display:"flex", margin:"auto 0 auto auto"}} height="95px !important" backgroundV widthV="155px">
                          <DropdownButton id="editDelete" title={MenuVertical()}>
                            <Dropdown.Item onClick={()=>this.hideShowOrganizationPopup()}>
                              {("Update Domain")}
                            </Dropdown.Item>
                            <div className='line'></div>
                            <Dropdown.Item  onClick={()=>this.showDeleteOrganization()}>
                              {("Delete Domain")}
                            </Dropdown.Item>
                          </DropdownButton>
                        </DownAngle>
                      </div>
                      <div className='name'>{getOrganizationData?.name}</div>
                      <div className='incomplete'>Incomplete process</div>
                      <div className='subText'>Click the {`"${"Connect Software"}"`} button to<br/> authorize HRIS Software.</div>
                    </div>
                  </div>
                  {<AddButton margin="8px" width="100%" onClick={()=>this.createConnection()}>
                    <span>Connect Software</span><ArrowRight/>
                  </AddButton>}
                </HrisCardDisconnect>
              </BackgroundCard>
            }
            {!getOrganizationData||getOrganizationData?.length==0&&<BackgroundCard width="200px">
              <AddButton margin="8px" onClick={()=>this.hideShowOrganizationDomainPopup()}>
                <AddIconBranding/><span>Add SSO Integration</span>
              </AddButton>
            </BackgroundCard>}
          </ShowFlexBox>
          <Heading>HRIS Integrations</Heading>
          <ShowFlexBox>
            {HrisActiveCardStatus?
              integrations?.map((data,index)=>
                <HrisCardComponent data={data} key={index} showSyncPopup={this.showSyncPopup} showHideDeleteConsumer={this.showHideDeleteConsumer} getApiDeck={this.getApiDeck}/>):
              getConsumers?.length>0?
                <BackgroundCard>
                  <HrisCardDisconnect margin="0px">
                    <div className='wrap'>
                      <div className='image'>
                        <img src={getConsumers[0]?.metadata?.image}/>
                      </div>
                      <div className='details'>
                        <div className='menu'>
                          <DownAngle  feed style={{display:"flex", margin:"auto 0 auto auto"}} height="50px !important" backgroundV>
                            <DropdownButton id="editDelete" title={MenuVertical()}>
                              <Dropdown.Item onClick={()=>this.showHideDeleteConsumer()} >
                                {("Delete")}
                              </Dropdown.Item>
                            </DropdownButton>
                          </DownAngle>
                        </div>
                        <div className='name'>{getConsumers[0]?.metadata?.account_name}</div>
                        <div className='incomplete'>Incomplete process</div>
                        <div className='subText'>Click the {`"${"Connect Software"}"`} button to<br/> authorize HRIS Software.</div>
                      </div>
                    </div>
                    {<AddButton margin="8px" width="100%" onClick={()=>this.getApiDeck()}>
                      <span>Connect Software</span><ArrowRight/>
                    </AddButton>}
                  </HrisCardDisconnect>
                </BackgroundCard>:
                <BackgroundCard width="200px">
                  <AddButton margin="8px" onClick={()=>this.showHideConsumerPopup()}>
                    {AddIconBranding(24,24)}<span>Add HRIS Integration</span>
                  </AddButton>
                </BackgroundCard>
            }
          </ShowFlexBox>
          {/* {this.props.companyBranding?.company_branding?.show_hris ? <>
            {showAdd&&!integrations.length>0&&consumerState?<AddUserCard>
              {<>
                <div className='hand'>
                  <div className='image'>
                    < img src={ImageUrl+"/Hris-image/hand.png"}/>
                  </div>
                </div>
                <div className='adduser'>
                  <div className='subtext'>
                    Click here to integrate HRIS software
                    of your company for quick access to
                    Invite all your users in one click.
                  </div>
                  <div className='skip'onClick={()=>this.hideAddCard()}>Skip</div>
                </div>
              </>}
            </AddUserCard>:null}
          </>:null} */}
          {showOrganization&&<UpdateOrganization show={showOrganization} onClose={this.hideShowOrganizationPopup} domainName={domainName} onChangeInput={this.onChangeInput} updateOrganizationData={this.updateOrganizationData} domainNameSecondary={domainNameSecondary} onRemoveSecondaryDomain={this.onRemoveSecondaryDomain}/>}
          {showOrganizationDomain&&<UpdateOrganization show={showOrganizationDomain} onClose={this.hideShowOrganizationDomainPopup} domainName={organizationDomainName} domainNameSecondary={organizationDomainNameSecondary} onChangeInput={this.onChangeInput} updateOrganizationData={this.createOrganizationData} type="create" onRemoveSecondaryDomain={this.onRemoveSecondaryDomain}/>}
          {showOrganizationDelete&&<DeletePostPopup
            showModal={showOrganizationDelete}
            onClose={this.showDeleteOrganization}
            deletePopupOrganization={1}
            deleteOrganization={this.deleteOrganization}
            string="domain"
          />}
          {showConnectionDelete&&<DeletePostPopup
            showModal={showConnectionDelete}
            onClose={this.showDeleteConnection}
            deletePopupOrganization={1}
            deleteOrganization={this.deleteConnection}
            string="connection"
          />}
          {<CreateConsumer
            show={showConsumerPopup}
            onClose={this.showHideConsumerPopup}
            companyInfo={companyInfo}
            companyLogo={companyLogo}
            createConsumer={this.createConsumer}
            showGeneratePopup={showGeneratePopup}
            updateConsumerField={this.updateConsumerField}
            onCloseGeneratePopup={this.onCloseGeneratePopup}
            showHideDeleteConsumer={this.showHideDeleteConsumer}
          />}
          {deleteConsumer&&<DeletePopup
            showModal={deleteConsumer}
            onClose={this.showHideDeleteConsumer}
            deleteConsumer={this.deleteConsumer}
          />}
          {this.syncPopup()}
        </div>
      </Layout>
    )
  }
}

HrisMain.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object,
  companyBranding: PropTypes.object,
  companyLogo: PropTypes.object,
  getCompanyBrandingDetails: PropTypes.func
};

const mapStateToProps = (state) => ({
  companyBranding: state?.wellnessDashboard?.companyBrandingDetails,
})

const mapDispatchToProps = (dispatch) => ({
  getCompanyBrandingDetails: (id) => dispatch(getCompanyBrandingDetails(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(HrisMain);
